<template>
  <div class="bg" :style="{ background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header></home-header>
    <div class="center">
      <div class="end">
        <div class="endText">距离会议结束还有15分钟确认提前结束？</div>
      </div>
      <div class="confirm">
        <div class="conButton" @click="conHandle">
          <div class="conText">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import moment from "moment";
export default {
  components: {
    HomeHeader,
  },
  data() {
    return {
        bgUrl:''};
  },
  created() {},
  mounted(){
      this.bgUrl = localStorage.getItem('bgUrl')
  },
  methods: {
    conHandle() {
      this.$router.push({ path: "/homePage" });
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .center {
    width: 70%;
    height: 70%;
    background: rgba(255, 255, 255, 0.1);
    margin: 6% auto;
    .end {
      width: 41%;
      height: 20%;
      margin: 0 auto;
      text-align: center;
      padding: 15%;
      .endText {
        font-size: 48px;
        color: #ffffff;
        font-family: SimHei;
        font-weight: bold;
        line-height: 80px;
      }
    }
    .confirm {
      width: 10%;
      height: 30%;
      margin: 0 auto;
      .conButton {
        width: 100px;
        height: 100px;
        background: linear-gradient(0deg, #1bf7e9, #2ad7ff);
        border-radius: 50%;
        .conText {
          font-size: 36px;
          color: #ffffff;
          text-align: center;
          line-height: 98px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/End.vue